<template>
<div>
  <div>

    <el-button  type="success" @click="sureFees()" v-if="ProcessState < 3">确认缴费</el-button>
    <el-button   v-if="ProcessState >= 3">费用已清缴</el-button>
  </div>
  <div class="form-page-title-info"><el-button  type="primary" @click="pushShow('temporary')">临时收费</el-button></div>
  <el-table height="30vh" v-loading="loading" v-if="pageData" :data="pageData.list" border style="width: 100%">
    <el-table-column prop="id" label="ID" width="80"></el-table-column>
    <el-table-column prop="h_name" label="业户" width="100"></el-table-column>
    <el-table-column prop="address" label="房产"></el-table-column>
    <el-table-column prop="charge_name" label="临时费用名称"></el-table-column>
    <el-table-column prop="charge" label="金额" width="100"></el-table-column>
    <el-table-column prop="payment_number" label="缴款方式" width="100"></el-table-column>
    <el-table-column prop="bill_number" label="票据号" width="110"></el-table-column>
    <el-table-column prop="user" label="操作人" width="80"></el-table-column>
    <el-table-column prop="remarks" label="备注"></el-table-column>
    <el-table-column prop="date" label="操作时间" width="140"></el-table-column>
  </el-table>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>

  <div style="margin-top: 10px;"></div>
  <div class="form-page-title-info"><el-button  type="primary" @click="pushShow('deposit')">押金收费</el-button></div>
  <el-table height="30vh" v-loading="loadingB" v-if="pageDataB" :data="pageDataB.list" border style="width: 100%">
    <el-table-column label="操作" width="120">
      <template slot-scope="data" >
        <el-button type="text" style="color: #574cfd;" @click="view(data.row.id)">查看明细</el-button>
      </template>
    </el-table-column>
    <el-table-column prop="id" label="ID" width="80" />
    <el-table-column prop="name" label="客户姓名" width="109"/>
    <el-table-column prop="house" label="房产"  width="300"/>
    <el-table-column prop="deposit_type" label="押金类型" width="100"/>
    <el-table-column prop="charge_date" label="收取日期" width="100"/>
    <el-table-column prop="charge_money" label="收取押金" width="100"/>
    <el-table-column prop="retreat_date" label="退还日期" width="100"/>
    <el-table-column prop="retreat_money" label="退还押金" width="100"/>
    <el-table-column prop="deposit_money" label="押金余额" width="100"/>
    <el-table-column prop="bill_number" label="票据号码" width="130"/>
    <el-table-column prop="beizhus" label="备注"  width="200"/>
    <el-table-column prop="date" label="添加时间" width="160"/>
    <el-table-column label="支付方式" width="120">
      <template slot-scope="data">
        {{ data.row.payment_name }}
      </template>
    </el-table-column>
  </el-table>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageDataB.total*1"
                   :page-size="pageDataB.pageSize*1" :current-page="pageDataB.page*1"
                   @current-change="pageChange2"></el-pagination>
  </div>
  <Modal v-model="modal3" ok-text="关闭" width="80%" title="明细" :loading="loadingModal">
        <div>
          <el-form style="height: 600px; overflow: auto">
            <div>
              <template>
                <el-table :data="detaileds" border style="width: 100%">
                  <el-table-column prop="mark" label="业务标记"></el-table-column>
                  <el-table-column prop="payment_name" label="结算方式" />
                  <el-table-column prop="money" label="金额" />
                  <el-table-column prop="operateDate" label="操作时间" />
                  <el-table-column prop="beizhus" label="备注" />
                  <el-table-column prop="names" label="操作人" />
                </el-table>
              </template>
            </div>
          </el-form>
        </div>
      </Modal>
</div>

</template>

<script>
export default {
  name: "PaymentFees",
  inject:['mainObj'],
  data(){
    return{
      ProcessState:0,
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 12,
        page: 1,
      },
      loadingB:false,
      pageDataB: {
        list: [],
        total: 0,
        pageSize: 12,
        page: 1,
      },
      modal3: false,
      loadingModal: false,
      detaileds: [],
    }
  },
  mounted() {
    this.getData();
    this.getList();
    this.getListB();
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getProcessState",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.ProcessState=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
      pushShow(url) {
        window.open('/#/order/'+url, '_blank');
      },
      sureFees() {
        const that = this;
        if(that.mainObj.id != '') {
          this.$confirm('是否确认缴费, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            ERP.postRequest({url:"admin/HouseFurnish/setProcessState",data:{id:that.mainObj.id,ProcessState:3}},ret=>{
              if(ret.code){
                this.$msgbox.alert(ret.msg||"操作成功")
                that.ProcessState = 3
              }else{
                this.$msgbox.alert(ret.msg||"查询失败")
              }
            })

          }).catch(() => {
            // this.$message({type: 'info',message: '已取消'});
          });
        }
      },
      pageChange(i) {
        this.pageData.page = i
        this.getList()
      },
      getList() {
        const that = this;
        that.loading = true;
        ERP.postRequest({
          url: "admin/HouseFurnish/temporaryList",
          data: {
            page: that.pageData.page,
            pageSize: that.pageData.pageSize,
            fitment_id: that.mainObj.id
          }
        }, res => {
          if(res.code == 200) {
            that.pageData.list = res.data
            that.pageData.total = res.count
            that.pageData.pageSize = res.pageSize
          }
            that.loading = false;
        })
      },
      pageChangeB(i) {
        this.pageDataB.page = i
        this.getListB()
      },
      getListB() {
        const that = this;
        that.loadingB = true;
        ERP.postRequest({
          url: "admin/HouseFurnish/depositList",
          data: {
            page: that.pageDataB.page,
            pageSize: that.pageDataB.pageSize,
            fitment_id: that.mainObj.id,
          }
        }, res => {
          if(res.code == 200) {
            that.pageDataB.list = res.data.data
            that.pageDataB.total = res.data.count
            that.pageDataB.pageSize = res.data.pageSize
          }
          that.loadingB = false;
        })
      },
      view(id) {
        this.modal3 = true;
        this.loadingModal = true;
        ERP.postRequest({
          url: "admin/Deposits/viewDeposit",
          data: {id: id}
        }, res => {
            this.detaileds = res.data;
            this.loadingModal = false;
        })
      }
  }
}
</script>

<style scoped>
.form-page-title-info{
	  width:100%;
	  padding: 4px 0px;
	  font-weight: 700;
	  line-height: 36px;
	  background-color: #f7f8fa;
	  border-bottom: 1px solid #e5e5e5;
    margin-top: 5px;
	}
  .pagination-wrap{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/components/preparation_entry/PaymentFees.vue